import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';

import {MyApp} from './app.component';

import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';

import {FormsModule} from '@angular/forms';

import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {TokenInterceptor} from './interceptor';

import {LoginProvider} from '../providers/login';
import {SubjectProvider} from '../providers/subject';
import {StudentProvider} from '../providers/student';
import {ResultProvider} from '../providers/result';

@NgModule({
    declarations: [
        MyApp,

    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(MyApp),
        HttpClientModule,
        FormsModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
    ],
    providers: [
        StatusBar,
        SplashScreen,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        LoginProvider,
        SubjectProvider,
        StudentProvider,
        ResultProvider
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts